import { NullDataHandlerService } from '../../core/services/null-data-handler.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/planting-site.service";
import * as i2 from "@angular/router";
export class PlantingSiteDetailsResolverService extends NullDataHandlerService {
    constructor(plantingSiteService, router) {
        super(router);
        this.plantingSiteService = plantingSiteService;
        this.router = router;
    }
    resolve(route, state) {
        let id = route.paramMap.get('siteId') || '';
        if (id == 'new')
            return {
                id: '',
                certificates: [],
                partners: [],
                areas: [],
                collections: [],
                species: [],
                pdfUrl: null
            };
        return this.plantingSiteService.getById(id).then((response) => {
            if (!response)
                this.redirectToNotFound();
            else
                return response;
        });
    }
}
PlantingSiteDetailsResolverService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PlantingSiteDetailsResolverService_Factory() { return new PlantingSiteDetailsResolverService(i0.ɵɵinject(i1.PlantingSiteService), i0.ɵɵinject(i2.Router)); }, token: PlantingSiteDetailsResolverService, providedIn: "root" });
